function MetricCard({
    title,
    value,
    unit,
    className = "",
    absolute = true
}) {
    return (
        <div
            className={`
                ${absolute ? "absolute" : ""}
                bg-white
                border
                border-slate-300
                rounded-md
                shadow-sm
                w-[140px]
                text-center
                py-2
                px-3
                ${className}
            `}
        >
            <div className="text-[11px] uppercase tracking-[2px] text-slate-400">
                {title}
            </div>

            <div className="mt-1 text2xl font-bold text-textPrimary">
                {value}
            </div>

            <div className="text-xs text-electricBlue">
                {unit}
            </div>
        </div>
    );
}

export default MetricCard